import React, { Component } from "react";
import "./BackgroundCarousel.css"; // style defined below

interface State {
  currentIndex: number;
}

class BackgroundCarousel extends Component<{}, State> {
  images = ["/01.png", "/02.png"];

  intervalId: any;

  constructor(props: {}) {
    super(props);
    this.state = {
      currentIndex: 0,
    };
  }

  componentDidMount() {
    this.intervalId = setInterval(this.nextSlide, 5000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  nextSlide = () => {
    this.setState((prevState) => ({
      currentIndex: (prevState.currentIndex + 1) % this.images.length,
    }));
  };

  goToSlide = (index: number) => {
    this.setState({ currentIndex: index });
  };

  render() {
    const { currentIndex } = this.state;
    return (
      <>
        <div className="carousel-container">
          <img
            src={this.images[currentIndex]}
            alt={`Slide ${currentIndex}`}
            className="carousel-image"
          />
          {currentIndex === 0 && (
            <div className="carousel-caption d-none d-md-block">
              <h5 style={{fontSize:'1.25rem',fontWeight:'500'}}>ExdioniStudio</h5>
              <p style={{fontSize:'1rem'}}>
                ExdioniStudio is meant for checking E&amp;O errors on policy
                documents.
              </p>
            </div>
          )}
          <div className="carousel-indicators">
            {this.images.map((_, index) => (
              <span
                key={index}
                className={`indicator ${
                  index === currentIndex ? "active" : ""
                }`}
                onClick={() => this.goToSlide(index)}
              ></span>
            ))}
          </div>
        </div>
      </>
    );
  }
}

export default BackgroundCarousel;
